import { render, staticRenderFns } from "./widget-submissions-layout.vue?vue&type=template&id=395a93c8&scoped=true&"
import script from "./widget-submissions-layout.vue?vue&type=script&lang=js&"
export * from "./widget-submissions-layout.vue?vue&type=script&lang=js&"
import style0 from "./widget-submissions-layout.vue?vue&type=style&index=0&id=395a93c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395a93c8",
  null
  
)

export default component.exports